"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HeaderTitle_1 = __importDefault(require("./HeaderTitle"));
exports.default = HeaderTitle_1.default;
